export default {
  nav: {
    coreLogic: '핵심 로직',
    profitMechanism: '수익 메커니즘',
    profitFlywheel: '수익 플라이휠',
    sysArch: '시스템 아키텍처',
    tradingExample: '거래 사례',
    cta: '시작하기',
    language: '언어',
  },
  hero: {
    badge: 'Poly Ai Claw 인텔리전스 엔진',
    title1: '예측에서',
    title2: '확률 차익거래로',
    desc: 'Polywin은 Poly Ai Claw 인텔리전스 엔진을 통해 예측 시장을 체계적인 차익거래 엔진으로 업그레이드합니다',
    ctaPrimary: 'Poly Ai Claw 엔진 시작',
    ctaSecondary: '데모 보기',
    statsEvents: '모니터링 이벤트',
    statsSuccessRate: '실행 성공률',
    statsExecTime: '실행 시간',
    cardTitle: '확률 편차 분석',
    cardBadge: 'EV 엣지 존',
    cardMarketProb: '시장 확률',
    cardAiProb: 'AI 확률',
    cardMarketImplied: '시장 내재 확률',
    cardAiTrue: 'AI 실제 확률',
    cardProbDiff: '확률 엣지',
  },
  coreLogic: {
    badge: 'PolyAi-Claw 결정 시스템',
    title1: '데이터 집계부터 복리 수익까지',
    title2: '완전 자동화 루프',
    desc: '다중 소스 데이터 → AI 모델링 → 확률 편차 → 자동 실행 → 복리 수익의 완전한 자동화 거래 루프',
    step0_title: '데이터 레이어',
    step0_sub: '다중 소스 집계',
    step0_i0: '정치 이벤트',
    step0_i1: '거시 경제',
    step0_i2: '소셜 센티먼트',
    step0_i3: '오더북 데이터',
    step1_title: 'AI 모델링',
    step1_sub: '베이즈 확률 업데이트',
    step1_i0: '실시간 데이터 입력',
    step1_i1: 'AI 모델링 엔진',
    step1_i2: '확률 계산',
    step1_i3: '모델 최적화',
    step2_title: '편차 감지',
    step2_sub: '확률 편차 식별',
    step2_i0: '시장 내재 확률',
    step2_i1: 'AI 실제 확률',
    step2_i2: 'EV 엣지 감지',
    step2_i3: '포지션 신호',
    step3_title: '온체인 실행',
    step3_sub: 'Polygon 자동 거래',
    step3_i0: '리스크 제어',
    step3_i1: '자본 배분',
    step3_i2: 'USDC 정산',
    step3_i3: '스마트 컨트랙트',
    step4_title: '복리 수익',
    step4_sub: '자동 재투자',
    step4_i0: '이벤트 정산',
    step4_i1: '수익 청산',
    step4_i2: '복리 계산',
    step4_i3: '재투자 루프',
    keyTitle: '핵심 목표',
    keyDesc: 'PolyAi-Claw의 목표는 시장에서 확률 오가격(Mispricing)을 지속적으로 찾아 체계적인 차익거래를 실행하는 것입니다.',
    keyHighlight: '확률 오가격을 지속적으로 찾아 체계적인 차익거래 실행',
  },
  profitMechanism: {
    badge: '핵심 수익 메커니즘',
    title1: 'PolyAi-Claw의',
    title2: '3가지 수익 메커니즘',
    desc: 'EV 엣지 감지, 밀리초 실행, 3단계 자본 관리로 안정적인 확률 차익거래 시스템 구축',
    m1_title: 'EV 엣지 감지',
    m1_sub: 'Probability Edge Detection',
    m1_desc: '핵심 로직: 시장 가격 ≠ 실제 확률. AI가 시장 내재 확률과 실제 확률의 편차를 감지하면 EV 엣지 존에 자동으로 진입하고 포지션을 트리거합니다.',
    m1_marketImplied: '시장 내재 확률',
    m1_aiTrue: 'AI 실제 확률',
    m1_probDiff: '확률 엣지',
    m1_note: '퀀트 펀드 옵션 차익거래 원리와 동일',
    m2_title: '밀리초 자동 실행',
    m2_sub: 'Millisecond Execution',
    m2_desc: '완전 자동화 실행 프레임워크로 인적 오류로 인한 차익거래 기회 손실을 방지합니다.',
    m2_i0_title: '밀리초 실행 속도',
    m2_i0_sub: '평균 <200ms',
    m2_i1_title: '완전 온체인 투명',
    m2_i1_sub: 'Polygon PoS',
    m2_i2_title: '인적 간섭 없음',
    m2_i2_sub: '스마트 컨트랙트 자동 정산',
    m2_network_label: '실행 네트워크',
    m2_network_val: 'Polygon + USDC',
    m3_title: '3단계 자본 관리',
    m3_sub: 'Three-Tier Risk Control',
    m3_desc: '전통적인 투기에서의 고레버리지와 단일 리스크를 피하는 3단계 자본 구조.',
    m3_i0_title: '안정 수익 풀',
    m3_i0_desc: '고확실성 확률 차익거래, 최저 리스크',
    m3_i1_title: '변동성 차익 풀',
    m3_i1_desc: '시장 변동성 포착, 높은 수익 탄력성',
    m3_i2_title: '헤지 보호 풀',
    m3_i2_desc: '저상관 이벤트 헤징, 시스템 리스크 감소',
    m3_risk: '단일 이벤트 노출 < 5%',
    formula_title: '확률 차익거래 공식',
    formula_marketPrice: '시장 가격',
    formula_aiTrue: 'AI 실제 확률',
    formula_trigger: '포지션 트리거',
    formula_arbitrage: '차익거래',
    formula_hiddenPct: '내재 60%',
    formula_evEdge: 'EV 엣지 +12%',
    formula_autoExec: '자동 실행',
  },
  fundManagement: {
    riskTitle: '핵심 리스크 제어 원칙',
    riskDesc: '시스템은 단일 이벤트 최대 노출 < 5%를 설정하여 단일 이벤트의 극단적인 결과가 전체 펀드 풀에 큰 영향을 미치지 않도록 합니다.',
    riskHighlight: '단일 이벤트 최대 노출 < 5%',
    stat_maxSingle: '최대 단일 투자',
    stat_maxSingleVal: '5%',
    stat_diversify: '자본 다양화',
    stat_diversifyVal: '20+ 이벤트',
    stat_stopLoss: '손절 메커니즘',
    stat_stopLossVal: '자동 트리거',
    vizTitle: '리스크 제어 시각화',
    viz_exposure: '노출 제어',
    viz_diversify: '자본 다양화',
    viz_correlation: '이벤트 상관관계',
    viz_stability: '전략 안정성',
  },
  techAdvantage: {
    badge: '핵심 장점',
    title1: '왜 PolyAi-Claw가',
    title2: '전통 예측 시장보다 우월한가?',
    dim_decision: '결정 기반',
    dim_monitor: '모니터링 주기',
    dim_execute: '실행 방법',
    dim_model: '인지 모델',
    dim_risk: '리스크 제어',
    human_decision: '감정 기반',
    human_monitor: '저주기',
    human_execute: '수동 주문',
    human_model: '주관적',
    human_risk: '경험 기반',
    ai_decision: '데이터 기반',
    ai_monitor: '고주기',
    ai_execute: '자동 실행',
    ai_model: '확률 모델',
    ai_risk: '알고리즘 관리',
    humanPredict: '인간 예측',
    adv1_title: '데이터 기반 vs 감정 기반',
    adv1_desc: 'PolyAi-Claw는 정치 이벤트, 거시 경제, 소셜 센티먼트, 오더북 데이터를 포함한 다중 소스 데이터로 모델링합니다.',
    adv1_label: '데이터 소스 수',
    adv2_title: '고주기 vs 저주기',
    adv2_desc: '시스템은 24/7 중단 없이 시장 변화를 모니터링하여 확률 편차 기회를 실시간으로 식별합니다.',
    adv2_label: '모니터링 주기',
    adv3_title: '자동 실행 vs 수동 주문',
    adv3_desc: 'Polygon 체인의 스마트 컨트랙트를 통한 밀리초 자동 실행으로 지연이나 오류 없이 차익거래 기회를 놓치지 않습니다.',
    adv3_label: '실행 속도',
    adv4_title: '알고리즘 관리 vs 경험 기반',
    adv4_desc: '3단계 자본 관리 시스템으로 단일 이벤트 노출을 5% 이하로 엄격히 제어합니다.',
    adv4_label: '리스크 제어',
    conclusion_title: '예측 시장에서 Poly Ai Claw 인텔리전스 엔진으로',
    conclusion_desc1: '이것은 PolyWin을 단순한 Prediction Market에서 업그레이드합니다',
    conclusion_brand: 'Poly Ai Claw 인텔리전스 엔진',
    conclusion_desc2: 'Poly Ai Claw 퀀트 예측 시스템',
  },
  productNarrative: {
    badge: '제품 포지셔닝',
    title: 'PolyWin의 진정한 정체성',
    desc: 'PolyWin은 단순한 예측 시장이 아니라 AI, 예측 시장, OpenClaw, 퀀트 트레이딩을 통합한 종합 시스템입니다.',
    item0_title: '확률 차익거래 시스템',
    item0_sub: '시장 오가격 지속 포착',
    item1_title: '규율적 실행 모델',
    item1_sub: '자동화, 감정 개입 없음',
    item2_title: 'AI 리스크 관리 엔진',
    item2_sub: '지능형 리스크 제어',
    visual_title: '3가지 시각적 표현',
    vis0_title: '① 확률 곡선 편차 차트',
    vis0_desc: 'AI 확률 곡선 vs 시장 가격 곡선을 보여주는 명확한 가격 편차 영역',
    vis0_ai: 'AI 확률',
    vis0_market: '시장 가격',
    vis0_diff: '확률 차이',
    vis1_title: '② 리스크 제어 레이더 차트',
    vis1_desc: '리스크 노출, 자본 다양화, 이벤트 상관관계, 전략 안정성 표시',
    vis1_exposure: '리스크 노출',
    vis1_diversify: '자본 분산',
    vis1_safe: '안전 구역',
    vis1_safeVal: '진입',
    vis2_title: '③ AI 자동 거래 흐름도',
    vis2_desc: '데이터 → AI → 실행 → 정산 → 복리의 완전한 루프 강조',
    vis2_exec: '실행 속도',
    vis2_execVal: '밀리초',
    vis2_auto: '자동화율',
    vis2_compound: '복리 루프',
    vis2_compoundVal: '지속',
    core_title: '핵심 가치 제안',
    core_desc: '자동화된 확률 가격 결정과 시간 복리 메커니즘을 통해 PolyAi-Claw는 리스크 제어를 보장하면서 예측 시장의 가격 편차를 지속적으로 포착합니다.',
    core_highlight: '자동화된 확률 가격 결정과 시간 복리 메커니즘',
    core_item0: '자동화된 확률 가격 결정',
    core_item1: '시간 복리 메커니즘',
    core_item2: '리스크 제어 보장',
    core_item3: '지속적인 편차 포착',
  },
  profitFlywheel: {
    badge: 'AI 기반 금융 성장 플라이휠',
    title1: 'PolyWin AI',
    title2: '수익 플라이휠 모델',
    desc: 'PolyWin의 성장은 단일 거래 수익에 의존하지 않고 AI 기반 지속 복리 시스템에 의존합니다',
    descHighlight: 'AI 기반 지속 복리 시스템',
    aiCore: 'AI Probability Engine',
    step1_title: '글로벌 데이터 입력',
    step1_sub: 'Global Data',
    step1_desc: 'AI가 뉴스 이벤트, 정치 변화, 거시 경제 데이터, 소셜 센티먼트, 예측 시장 오더북을 지속 모니터링',
    step1_tech: '50+ 데이터 소스',
    step1_techDetail: '다중 소스 실시간 융합',
    step2_title: 'AI 확률 모델링',
    step2_sub: 'Probability Modeling',
    step2_desc: '베이즈 확률 모델, 센티먼트 수정 모델, 시장 가격 모델을 사용하여 실제 확률 계산',
    step2_tech: '베이즈 모델',
    step2_techDetail: '동적 확률 실시간 수정',
    step3_title: '확률 편차 발견',
    step3_sub: 'Probability Edge',
    step3_desc: 'AI 실제 확률 > 시장 내재 확률일 때 EV Positive Opportunity로 식별',
    step3_tech: 'EV 편차 >5%',
    step3_techDetail: '양의 기대값 자동 감지',
    step4_title: '자동 거래 실행',
    step4_sub: 'Algorithmic Execution',
    step4_desc: '시스템이 포지션 구축, 헤징, 주문 실행을 자동 완료',
    step4_tech: '스마트 컨트랙트',
    step4_techDetail: '<200ms 밀리초 실행',
    step5_title: '예측 시장 수익',
    step5_sub: 'Market Profit',
    step5_desc: '이벤트 결과 확인 또는 시장 확률 회귀 시 차익거래 수익 획득',
    step5_tech: 'Polygon PoS',
    step5_techDetail: '온체인 자동 정산',
    step6_title: '수익 회수',
    step6_sub: 'Capital Recycling',
    step6_desc: '시스템이 수익 자금을 자동으로 펀드 풀에 회수',
    step6_tech: 'USDC 정산',
    step6_techDetail: '스테이블코인 환율 손실 없음',
    step7_title: '복리 성장',
    step7_sub: 'Compounding Capital',
    step7_desc: '펀드 풀 규모 확대 후 AI는 더 큰 시장, 더 많은 이벤트에 참여 가능',
    step7_tech: '자동 복리',
    step7_techDetail: '수익 자동 재투자 루프',
    step8_title: '더 큰 자본 규모',
    step8_sub: 'Larger Liquidity Pool',
    step8_desc: '더 큰 자본 규모는 더 높은 거래 능력, 더 안정적인 수익, 더 강한 시장 영향력을 의미',
    step8_tech: '유동성 확장',
    step8_techDetail: '규모가 클수록 장점 강화',
    sum0_label: '데이터 레이어',
    sum0_tech: '50+ 다중 소스 스트림',
    sum0_detail: '베이즈 실시간 모델링',
    sum1_label: '실행 레이어',
    sum1_tech: '스마트 컨트랙트 자동화',
    sum1_detail: 'Polygon PoS 온체인 정산',
    sum2_label: '정산 레이어',
    sum2_tech: 'USDC 스테이블코인',
    sum2_detail: '환율 손실 없는 정산',
    sum3_label: '복리 레이어',
    sum3_tech: '자동 재투자',
    sum3_detail: '규모 확장 순환',
    key0_title: '자기 강화 루프',
    key0_desc: '모든 수익이 시스템 능력을 강화하여 지수적 성장을 실현',
    key1_title: 'AI 기반 성장',
    key1_desc: '성장은 추천에 의존하지 않고 AI 시스템 자체의 확률 차익거래 능력에 의존',
    key2_title: '지속 복리 시스템',
    key2_desc: '자동화된 수익 회수 및 재투자로 펀드 규모 지속 확대',
    formula_title: '플라이휠 성장 공식',
    f0_label: 'AI 데이터',
    f1_label: '확률 차익거래',
    f2_label: '수익',
    f3_label: '복리',
    f4_label: '더 많은 자본',
    f5_label: '더 많은 차익거래',
    connected: '연결됨 · 실시간',
  },
  sysArch: {
    badge: 'Official Architecture',
    title1: 'PolyAi-Claw AI',
    title2: '시스템 아키텍처',
    desc: '데이터 수집부터 자동 정산까지의 완전한 AI 결정 시스템',
    coreBadge: '핵심 AI 두뇌',
    feat0_title: '완전한 AI 시스템 구조',
    feat0_desc: '단순한 전략이 아닌 데이터 수집, 지능형 분석, 리스크 제어에서 자동 실행까지의 완전한 AI 결정 시스템',
    feat1_title: '퀀트 펀드급 리스크 제어',
    feat1_desc: '전문 퀀트 펀드의 리스크 제어 모델 (노출 제어, 상관관계 헤징, 동적 자본 배분)',
    feat2_title: '확장 가능한 아키텍처',
    feat2_desc: '다중 시장, 다중 체인, 다중 전략으로 확장 가능',
    dataflow_title: '데이터 흐름',
  },
  tradingExample: {
    badge: '실전 사례 분석',
    title1: 'PolyAi-Claw BTC',
    title2: '5분 차익거래 전략',
    desc: '시스템은 3가지만 합니다: 이상 변동 감지 → 마지막 60초 확률 판단 → 안전 구역 거래',
    s1_title: 'BTC Market Data',
    s1_sub: '실시간 시장 모니터링',
    s1_notice: '전략 트리거 조건 샘플 데이터',
    s1_price: '현재 가격',
    s1_eg: '예시',
    s1_priceVol: '가격 변동',
    s1_vol: '거래량',
    s1_depth: '오더북 깊이',
    s1_trigger: '트리거: 변동 ≥ 100 USD',
    s1_met: '충족',
    s2_title: 'PolyAi-Claw Engine',
    s2_sub: 'AI 확률 계산',
    s2_marketImplied: '시장 내재 확률',
    s2_aiTrue: 'AI 실제 확률',
    s2_yes: 'YES',
    s2_probDiff: '확률 엣지',
    s2_safe: '안전 거래 구역 진입',
    s3_title: 'Auto Trade + Profit',
    s3_sub: '자동 실행 및 수익',
    s3_exec: '거래 실행',
    s3_buyYes: 'YES 매수',
    s3_buyPrice: '매수 가격',
    s3_settlement: '예측 시장 정산',
    s3_correct: '정확한 예측',
    s3_profit: '거래당 수익',
    s3_avg: '평균 수익률',
    s3_recycle: '수익을 풀에 회수',
    chart_title: 'AI 확률 vs 시장 확률 편차 차트',
    chart_sub: 'Poly Ai Claw 엔진 vs 시장 가격 확률 편차 실시간 추적',
    chart_live: 'Live Analysis',
    chart_curDev: '현재 편차',
    chart_signal: '차익거래 신호',
    chart_signalVal: '트리거됨',
    chart_winRate: '승률 예측',
    chart_bottom_implied: '시장 내재 확률',
    chart_bottom_dev: '확률 편차 구역',
    chart_bottom_dev_sub: '차익거래 기회 트리거됨',
    chart_bottom_ai: 'AI 실제 확률',
    chart_bottom_ai_sub: 'Poly Ai Claw 모델 출력',
    chart_bottom_implied_sub: '시장 가격 기반',
    chart_marketProb: '시장 내재 확률',
    chart_aiProb: 'AI 실제 확률',
    chart_deviationArea: '차익거래 편차 구역',
    maxDeviation: '최대 편차',
    deviation: '편차',
    flow_title: '완전한 전략 흐름',
    flow0_title: 'BTC 데이터 모니터링',
    flow0_desc: '실시간 가격/거래량',
    flow1_title: '변동성 감지',
    flow1_desc: '≥ 100 USD',
    flow2_title: '시간 필터',
    flow2_desc: '마지막 60초',
    flow3_title: '승률 평가',
    flow3_desc: '≥ 60-70%',
    flow4_title: '자동 실행',
    flow4_desc: 'YES/NO 매수',
    flow5_title: '시장 정산',
    flow5_desc: '1 USDC',
    flow6_title: '복리 수익',
    flow6_desc: '3%-10%',
    risk0_title: '리스크 구조',
    risk0_i0: '단일 이벤트 자본 한도 < 5%',
    risk0_i1: '다중 이벤트 분산',
    risk0_i2: 'AI 동적 손절',
    risk1_title: '타이밍 전략',
    risk1_i0: '마지막 60초 실행',
    risk1_i1: '감정적 거래 방지',
    risk1_i2: '더 완전한 정보',
    risk2_title: '역사적 성과',
    risk2_i0: '역사적 승률 80%-90%',
    risk2_i1: '평균 수익 3%-10%',
    risk2_i2: '안정적인 차익거래 모델',
  },
  crossPlatform: {
    badge: '크로스 플랫폼 예측 차익거래',
    title1: 'PolyAi CLaw',
    title2: '크로스 플랫폼 예측 시장 차익거래 로직',
    desc: 'Polymarket(Web3)과 Kalshi(법정화폐)를 연결하여 가격 편차 포착, 지능형 매칭 + 초고속 실행',
    polymarket: 'Polymarket',
    kalshi: 'Kalshi',
    web3: 'Web3',
    fiat: '법정화폐',
    claw: 'CLaw',
    matched: '✓ 매칭됨',
    matching: '매칭 중...',
    sec1_badge: '01',
    sec1_accuracy: '99%+ 정확도',
    sec1_title: '지능형 시장 매칭',
    sec1_desc: '두 플랫폼의 이벤트가 시맨틱 AI에 의해 자동으로 바인딩됩니다',
    sec2_badge: '02',
    sec2_ms: '밀리초 실행',
    sec2_title: '통합 연결 및 초고속 거래',
    sec2_desc: '통합 API/SDK로 다중 플랫폼 연결, 밀리초 동기 주문으로 차익거래 창 포착',
    connected: '연결됨 · 실시간',
    latency: '주문 지연',
    dailyEvents: '일일 매칭 이벤트',
    successRate: '실행 성공률',
    platforms: '동기화 플랫폼 수',
    sec3_badge: '03',
    sec3_analytics: 'Live Analytics',
    sec3_title: '차익거래 데이터 시각화',
    sec3_desc: '실시간 가격 편차, 차익거래 수익 및 성장 추세',
    priceDeviation: '가격 편차 분포',
    volumeTitle: '월별 거래량 (K USDC)',
    h1Volume: 'H1 누적 거래량 (USDC)',
    arbIndicators: '차익거래 장점 지표',
    arbSuccess: '스프레드 차익거래 성공률',
    semanticAccuracy: '시맨틱 매칭 정확도',
    liquidity: '크로스 플랫폼 유동성',
    hedgeCoverage: '헤지 커버리지율',
  },
  mathAlgo: {
    badge: '정밀 고급 수학 알고리즘',
    title1: 'Polymarket 차익거래는',
    title2: '단순한 수학 문제가 아닙니다',
    quote: '당신이 아직 이 덧셈 문제를 수동으로 계산하는 동안, 퀀트 시스템은 이미 완전히 다른 일을 하고 있습니다.',
    quoteHighlight1: '수동으로 계산',
    quoteHighlight2: '완전히 다른 일',
    ch0_title: '차익거래란? 왜 Polymarket에 이렇게 많나?',
    ch0_tag: '시장 비효율성',
    ch1_title: '크로스 시장 차익거래: 논리적 의존성',
    ch1_tag: '조합 수학',
    ch2_title: 'Bregman 투영: 최적 차익거래 규모 계산',
    ch2_tag: '볼록 최적화',
    pipeline_title: 'Polymarket 차익거래 시스템 — 전체 아키텍처',
    layer0: '레이어 1: 데이터 수집',
    layer1: '레이어 2: 의존성 감지',
    layer2: '레이어 3: 3단계 최적화 엔진',
    layer3: '레이어 4: 실행 및 포지션 관리',
    annualProfit: '연간 총 추출 수익: $39,688,585',
    venn_title: '논리적 의존성: P(5% 대승) ⊆ P(승리)',
    contradiction: '모순! P(부분집합) > P(전체집합) → 차익거래 신호 트리거',
    contradiction_sub: '0.55 > 0.48 → 논리적 모순 → 차익거래 기회',
    combinations: '조합 수',
    brutal: '무차별 열거 불가능',
    integerConstraints: '정수 프로그래밍 제약',
    replaces: '16,384번 열거 대체',
    bregman_title: 'KL 발산 vs 유클리드 거리',
    coreData: '핵심 데이터',
    pipeline4: '시스템 4단계 파이프라인',
    annualReturn: '연간 수익 ≈ $3,968만',
    whyNotEnough_title: '왜 "가격 합계 = $1"이 충분하지 않나?',
    singleMarket: '단일 시장 — 표면적으로 정상',
    crossMarket: '크로스 시장 — 지수적 폭발',
  },
  mathProfit: {
    ch3_title: 'Frank-Wolfe 알고리즘: 단계적 답 근사',
    ch3_tag: '반복 알고리즘',
    ch3_chapter: '제 04장',
    execTitle: '비원자적 실행 위험',
    profitStructure: '수익 구조 (2024.4 – 2025.4)',
    totalProfit: '합계: $39,688,585',
    top10: 'TOP 10이 20.5% 차지',
    kellyFormula: '수정 Kelly 포지션 공식',
    preTrade: '사전 거래 4가지 체크포인트',
    gate0: '유동성 충분?',
    gate1: '슬리피지 허용?',
    gate2: '슬리피지 후에도 수익?',
    gate3: '수익 > $0.05 → 실행',
  },
  safuFund: {
    badge: '자산 보안 보장',
    title: 'Polywin SAFU 펀드',
    titleHighlight: 'SAFU 펀드',
    desc: '온체인 잠금 준비금, 투명하고 실시간 검증 가능 — 당신의 자산, 우리가 지킵니다',
    reserveLabel: 'Total Reserve · USDC · Ethereum Mainnet',
    verified: '온체인 검증됨',
    mainDesc: 'Polywin 팀은 이더리움 메인넷에 1,000만 USDC SAFU 보안 준비 기금을 잠금했습니다.',
    mainDescHighlight: '1,000만 USDC',
    contractLabel: '컨트랙트 주소',
    etherscanBtn: 'Etherscan에서 확인',
    stat0_label: '준비금 규모',
    stat0_sub: 'USDC',
    stat1_label: '온체인 잠금률',
    stat1_sub: 'On-Chain',
    stat2_label: '검증 가능',
    stat2_sub: 'Real-time',
    stat3_label: '역사적 지급',
    stat3_val: '$0',
    stat3_sub: '무손실 기록',
    f0_title: '온체인 잠금',
    f0_desc: '자금의 100%가 이더리움 메인넷 스마트 컨트랙트에 잠겨 있습니다',
    f1_title: '완전 투명',
    f1_desc: '누구나 Etherscan을 통해 실시간으로 잔액과 거래 내역을 볼 수 있습니다',
    f2_title: '신속 보상',
    f2_desc: '보안 사건 확인 후 72시간 이내 보상 절차 시작',
    f3_title: '독립 감사',
    f3_desc: '제3자 보안 기관이 계약 코드를 정기적으로 감사합니다',
  },
  cta: {
    badge: '지금 시작',
    title1: '시작하기',
    title2: 'Poly Ai Claw',
    title3: '인텔리전스 엔진',
    desc: '코딩 경험 불필요 — 3분 만에 AI 전략 구성',
    btn: 'AI-Claw 시작',
    trust0: 'Polygon 공식 파트너',
    trust1: '감사 기관 인증',
    trust2: '10,000+ 활성 사용자',
    trust3: '$50M+ 누적 거래량',
  },
  footer: {
    tagline: 'Poly Ai Claw 인텔리전스 엔진',
    product: '제품',
    resources: '리소스',
    social: '소셜 미디어',
    link0: 'Poly AI-Claw 알고리즘',
    link1: '리스크 제어 시스템',
    link2: '데이터 API',
    link3: '개발자 문서',
    res0: '튜토리얼',
    res1: '전략 사례',
    res2: '백서',
    res3: '커뮤니티 포럼',
    copyright: '© 2026 PolyWin. All rights reserved.',
    privacy: '개인정보 처리방침',
    terms: '서비스 약관',
  },
};
